import gql from 'graphql-tag';

export const GET_USER_INFO = gql`
  query {
    user: me {
      id
      name
      email
      role
      phone
    }
  }
`;

export const GET_HKDU_USER_INFO = gql`
  query getHKDUUserInfo($id: uuid!) {
    user: hkdutest_users(where: { id: { _eq: $id } }) {
      real_avatar
      doctor {
        id
        name
        hkdu_member_no
      }
    }
  }
`;
